import {
  connectionUrlRewrite,
  fetchCredentialById,
  selectCredentialById,
} from "@app/deploy";
import {
  useDispatch,
  useLoader,
  useLoaderSuccess,
  useSelector,
} from "@app/react";
import { useState } from "react";
import { ButtonSensitive } from "./button";
import { LoadingSpinner } from "./loading";
import { PreCode, listToInvertedTextColor } from "./pre-code";

export const DatabaseCredentialSecret = ({
  envId,
  credentialId,
  externalHost = "",
  portMapping = [],
}: {
  envId: string;
  credentialId: string;
  externalHost?: string;
  portMapping?: [number, number][];
}) => {
  const dispatch = useDispatch();
  const [isShowing, setIsShowing] = useState(false);

  const fetchAction = fetchCredentialById({
    id: credentialId,
    withSensitiveExtras: true,
  });
  const loader = useLoader(fetchAction);

  const credential = useSelector((s) =>
    selectCredentialById(s, { id: credentialId }),
  );

  const hasFetchedSensitiveData = Boolean(
    credential.id && credential.connectionUrl,
  );

  useLoaderSuccess(loader, () => {
    setIsShowing(true);
  });

  const handleToggle = () => {
    if (!hasFetchedSensitiveData && !isShowing && !loader.isLoading) {
      dispatch(fetchAction);
    } else {
      setIsShowing(!isShowing);
    }
  };

  let buttonContent = isShowing ? "Hide" : "Show";
  if (loader.isLoading) {
    buttonContent = "Loading...";
  }

  const displaySecret = credential.connectionUrl
    ? connectionUrlRewrite(credential.connectionUrl, externalHost, portMapping)
    : "";

  return (
    <div className="flex gap-4">
      {isShowing ? (
        <PreCode
          segments={listToInvertedTextColor([displaySecret])}
          allowCopy
        />
      ) : null}
      <div>
        <ButtonSensitive
          envId={envId}
          className={isShowing ? "mt-2 px-0" : "px-0"}
          size="sm"
          variant="white"
          onClick={handleToggle}
          disabled={loader.isLoading}
        >
          {loader.isLoading ? (
            <div className="flex items-center gap-2">
              <LoadingSpinner variant="sm" />
              {buttonContent}
            </div>
          ) : (
            buttonContent
          )}
        </ButtonSensitive>
      </div>
    </div>
  );
};
